var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isValidJsonString)?_c('a',{staticClass:"experience-link",attrs:{"href":_vm.experienceLink,"target":"_blank"}},[_vm._v("\n    "+_vm._s(_vm.experience.name)+"\n  ")]):_c('span',[_vm._v("Invalid Experience")])])}
var staticRenderFns = []

export { render, staticRenderFns }